'use strict'

moduleEditorPanel = angular.module('editorPanel.controller', ["api.widget", "services.layoutEditor.sectionDragDrop"])

moduleEditorPanel.controller "EditorPanelCtrl", ["$scope", "$state", "$timeout", "ns", "$injector", "Section", "Site", "$cookies", "$rootScope", "Restangular", "Modal", "Template", "$sce", "State", "Page", "$filter", ($scope, $state, $timeout, ns, $injector, Section, Site, $cookies, $rootScope, Restangular, Modal, Template, $sce, State, Page, $filter) ->
  $scope.currentEditorTab = ""
  $scope.currentNavEditorTab = ""
  $scope.sectionsCollection = []
  $scope.widthType = "px"
  $scope.siteSettings = Modal.siteSettings
  $scope.favoriteSettings = Modal.favoriteSettings

  $scope.togglePagesSettings = ->
    $scope.popoverOpen = !$scope.popoverOpen
    return
  $scope.closePagesSettings = ->
    $scope.popoverOpen = false
    return
  $scope.pagesPopoverOpen = ->
    $("[ng-click='togglePagesSettings()']").scope().togglePagesSettings()
    return

  # Fonts

  $scope.concatFonts = ->
    if Editor.Instrumentations.fonts
      Editor.Instrumentations.fonts.concat Editor.Instrumentations.defaultFonts
  $scope.state = $state

  # Edit template methods

  $scope.saveSite = (site, siteSettingsForm) ->
    return false if siteSettingsForm.$invalid
    site = angular.copy site
    $scope.savingSite = true
    Site.update(site).then ->
      $scope.savingSite = false
      applyStyleToTemplate site
      return
    , ->
      $scope.savingSite = false
  $scope.newsPages = ->
    if $rootScope.site
      _.filter($rootScope.site.pages, {type: "news"})
  $scope.shopPages = ->
    if $rootScope.site
      _.filter($rootScope.site.pages, {type: "shop"})
  $scope.getPageNameById = (id) ->
    pages = _.filter $rootScope.site.pages, {id: id}
    return "" if !id || pages.length is 0
    pages[0].name
]



// WEBPACK FOOTER //
// ./src/app/editor/editorPanel.controller.coffee